<div class="motivator flex-shrink-1 d-flex flex-column mt-2 align-items-center">
  <div class="w-100" *ngIf="_message">
    {{ _message }}
  </div>
  <div
    class="w-100 express-shipping-message"
    [innerHtml]="_expressShippingMessage"
    *ngIf="_expressShippingMessage"
  ></div>
  <div class="w-100 mt-1" *ngIf="!_expressShippingMessage">
    {{ _success }}
    <div class="progress" *ngIf="_total < _maxthreshold">
      <div
        class="progress-bar"
        role="progressbar"
        [style.width]="_total / 100 + '%'"
        aria-valuenow="25"
        aria-valuemin="0"
        aria-valuemax="100"
      ></div>
    </div>
  </div>
</div>
